import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'slashes', 'Slashes', [["path",{"d":"M14 5l-10 14"}],["path",{"d":"M20 5l-10 14"}]]);